import LegacyUnits              from 'scripts/defa/legacy/collection-legacy-units';
import LegacyController         from 'scripts/defa/legacy/controller-legacy-controller';
import LegacyUnit               from 'scripts/defa/legacy/model-legacy-unit';
import LegacyUser               from 'scripts/defa/legacy/model-legacy-user';
import LegacyRouter             from 'scripts/defa/legacy/router-legacy-router';
import LegacyFlow               from 'scripts/defa/legacy/view-legacy-flow';
import LegacyUnitCollectionView from 'scripts/defa/legacy/view-legacy-unit-collection-view';
import LegacyUnitContainer      from 'scripts/defa/legacy/view-legacy-unit-container';
import LegacyUnitSnippet        from 'scripts/defa/legacy/view-legacy-unit-snippet';
import Module                   from 'scripts/module';

const LegacyModule = new Module( 'LegacyModule', {
	collections: {
		LegacyUnits
	},
	controllers: {
		LegacyController
	},
	models     : {
		LegacyUser,
		LegacyUnit
	},
	routers    : {
		LegacyRouter
	},
	views      : {
		LegacyFlow,
		LegacyUnitCollectionView,
		LegacyUnitContainer,
		LegacyUnitSnippet
	}
	
} );
export default LegacyModule;